export default {
  state: {
    new: [],
    all: [],
  },
  mutations: {
    addNotices(state, payload) {
      if (!state.new) {
        state.new = [];
      }

      if (!state.all) {
        state.all = [];
      }

      payload.forEach((notice) => {
        if (!state.all.find(n => n.notice_id === notice.notice_id)) {
          if (!state.new.find(n => n.notice_id === notice.notice_id)) {
            state.new.push(notice);
          }
        }
      });
    },
    markAsSeen(state, payload) {
      const i = state.new.findIndex(n => n.notice_id === payload.notice_id);
      if (i > -1) {
        state.new.splice(i, 1);
        state.all.push(payload);
      } else {
        this.$container.logger.log('Tried to mark a notice as seen that does not exist.');
      }
    },
  },
  actions: {
    async loadNotices({ commit }, memberId) {
      const res = await this.$container.dao.getNotices(memberId);
      const notices = res.data;

      commit('addNotices', notices);
    },
    markAsSeen({ commit }, payload) {
      commit('markAsSeen', payload);
    },
  },
};
